import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";

export class ShipperAvatarCtrl implements IController {
  shipper: any;
  size:string;
  doUpload:boolean;

  private sizeLimit: number;//kb

  /* @ngInject */
  constructor(private $shipper, public commonsAlertsService: CommonsAlertsService, private $mdToast, private $translate) {
  }

  $onInit() {

    this.sizeLimit = 500;
  }

  onUpload = (result) => {
    const imageUrl = _.get(result, 'data.url');
    const shipperCopy = angular.copy(this.shipper);
    _.set(shipperCopy, 'user.avatarUrl', imageUrl);
    const shipperRef = this.$shipper(shipperCopy.id);
      shipperRef.$lock();
      shipperRef.$post(shipperCopy)
        .then(() => {
          shipperRef.$get()
            .then(() => {
              this.$mdToast.show(
                this.$mdToast.simple()
                  .textContent(this.$translate.instant('Updated shipper avatar image')));
              shipperRef.$unlock();
            });
        });
  }

  onSizeMismatch = () => {
    this.commonsAlertsService.fileSizeError();
  }
}

angular
  .module('bringoz.admin.shippers')
  .component('shipperAvatar', {
    bindings: {
      shipper: '<',
      size: '@',
      doUpload: '<?'
    },
    template: require('./shipper-avatar.html').default,
    controller: ShipperAvatarCtrl
  });
